export const SKELETON_CATALOGUE_MOBILE = 'skeleton-catalogue-mobile';
export const SKELETON_CATALOGUE_MOBILE_CONTENT = 'skeleton-catalogue-mobile-content';
export const SKELETON_MAIN_CATEGORY_MOBILE = 'skeleton-main-category-mobile';
export const SKELETON_SUB_CATEGORY_MOBILE_ROOT = 'skeleton-sub-category-mobile-root';
